module.exports = __webpack_public_path__ + "static/prasant-photo-5b9746991bb011da27e46238cc50de32.jpg";